import { Flex, Text, useToast } from '@chakra-ui/react'
import { useEffect, useState } from 'react'
import { FindUser } from '../../../../components/FindBox'
import { WhiteContainer } from '../../../../components/WhiteContainer'
import { iPermissaoFuncionalidade } from '../../../../contexts/AuthContext'
import { iNomeId } from '../../../../interfaces'
import { appApi } from '../../../../services/appApi'
import { Body } from '../../../Layouts/Body'
import { TabelaPermissoesIndividuais } from '../Components/TabelaPermissoesIndividuais'

export const PermissoesIndividuais: React.FC = () => {
  const toast = useToast()
  const [Colaboradores, setColaboradores] = useState<iNomeId[]>([])
  const [ColaboradorId, setColaboradorId] = useState<string>('')
  const [Permissoes, setPermissoes] = useState<iPermissaoFuncionalidade[]>([])
  const [IsLoading, setIsLoading] = useState(false)

  useEffect(() => {
    appApi.get('Colaborador/Select')
      .then(res => setColaboradores(res.data))
      .catch(err => console.log(err))
  }, [])

  function SelecionarColaborador(id: string): void {
    setColaboradorId(id)
    if (id === '') {
      setPermissoes([])
      return
    }
    setIsLoading(true)
    appApi.get(`permissoes/individual?cid=${id}`)
      .then(res => setPermissoes(Array.isArray(res.data) ? res.data : (res.data?.permissoes ?? [])))
      .catch(err => {
        console.log(err)
        toast({
          title: 'Não foi possível carregar as permissões deste colaborador',
          status: 'error',
          duration: 4000,
          isClosable: true,
          position: 'top-right'
        })
      })
      .finally(() => setIsLoading(false))
  }

  function AtualizarPermissao(modulo: string, funcionalidade: string, tipoUsuario: number, permitir: boolean): void {
    const copy = [...Permissoes]
    const pos = copy.findIndex(e => e.modulo === modulo && e.funcionalidade === funcionalidade && e.tipoUsuario === tipoUsuario)
    if (pos !== -1) {
      copy[pos] = { ...copy[pos], permitir }
    } else {
      copy.push({ modulo, funcionalidade, tipoUsuario, permitir })
    }
    setPermissoes(copy)

    appApi.post('permissoes/individual', { colaboradorId: ColaboradorId, permissoes: copy })
      .catch(err => {
        console.log(err)
        toast({
          title: 'Erro ao salvar a permissão',
          status: 'error',
          duration: 4000,
          isClosable: true,
          position: 'top-right'
        })
      })
  }

  return (
    <Body isLoading={IsLoading}>
      <h2>Permissões individuais</h2>
      <WhiteContainer margin='1rem 0'>
        <Flex flexDir={'column'} gap={'2rem'}>
          <Flex flexDir={'column'} maxW={'25rem'}>
            <Text fontWeight={'700'} marginBottom={'.5rem'}>Colaborador</Text>
            <FindUser
              lista={Colaboradores}
              onChoice={SelecionarColaborador}
              selecionado={ColaboradorId}
              placeholder='Buscar colaborador'
              isNotUser
              mostrarEmail
            />
          </Flex>

          {
            ColaboradorId === ''
              ? <Text color={'var(--Gray3)'}>Selecione um colaborador para configurar as permissões.</Text>
              : (
                  <>
                    <Flex flexDir={'column'}>
                      <h3>Jornada</h3>
                      <TabelaPermissoesIndividuais permissao={Permissoes.filter(e => e.modulo === 'Jornada')} onToggle={AtualizarPermissao} />
                    </Flex>

                    <Flex flexDir={'column'}>
                      <h3>Desempenho</h3>
                      <TabelaPermissoesIndividuais permissao={Permissoes.filter(e => e.modulo === 'Desempenho')} onToggle={AtualizarPermissao} />
                    </Flex>

                    <Flex flexDir={'column'}>
                      <h3>Engajamento</h3>
                      <TabelaPermissoesIndividuais permissao={Permissoes.filter(e => e.modulo === 'Engajamento')} onToggle={AtualizarPermissao} />
                    </Flex>

                    <Flex flexDir={'column'}>
                      <h3>Organograma</h3>
                      <TabelaPermissoesIndividuais permissao={Permissoes.filter(e => e.modulo === 'Organograma')} onToggle={AtualizarPermissao} />
                    </Flex>
                  </>
                )
          }
        </Flex>
      </WhiteContainer>
    </Body>
  )
}
